import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";

export interface ExportStage {
  catalogIds: string[];
}

@Injectable()
export class ExportStageService {
  private readonly apiUrl = 'api/ExportContainer';

  constructor(private http: HttpClient) {}

  public getExportStage(customerId: string): Promise<ExportStage> {
    const url = `${this.apiUrl}/getExportStage`;
    const params = new HttpParams().append('customerId', customerId);
    return lastValueFrom(this.http.get<ExportStage>(url, { params }));
  }

  public addCatalogToStage(catalogId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/addCatalogToExportStage`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post(url, null, { params }));
  }

  public removeCatalogFromStage(catalogId: string, customerId: string): Promise<any> {
    const url = `${this.apiUrl}/removeCatalogFromExportStage`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId);
    return lastValueFrom(this.http.post(url, null, { params }));
  }
}
